//#region IMPORTS
import { useBadgeColor } from "../../hooks/useBadgeColors";
import classNames from "../../helpers/classNames";
//#endregion

//#region INTERFACE
type Props = {
  value?: string | null;
};
//#endregion

export function MainBadge({ value }: Props) {
  const colorClasses = useBadgeColor(value);
  //#region RENDER
  return value && value !== "---" ? (
    <span
      className={classNames(
        colorClasses,
        "inline-flex items-center rounded-full px-3 py-1 text-xs font-medium"
      )}
    >
      {value ?? "Unknown"}
    </span>
  ) : (
    <span className="text-xs font-medium">---</span>
  );
  //#endregion
}
